<template>
    <div style="display: flex;" :style="flexDir">
        <button v-if="contentHeight > heightLimit" class="moreBtn" @click="toggleExpand">
            {{label}}
        </button>
        <div :class="{'expandableContent': contentHeight > heightLimit, 'expanded': isExpanded}" :style="currHeight" @click="toggleExpand()">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "show-more",
    props:[
        "actionWord", // the action word used for expanding the content
        "heightLimit" // height before expanding
    ],
    data: () => ({
        contentHeight: 0,
        label: "Read More",
        isExpanded: false,
        contentRef: null,
        flexDir: {"flex-direction": "column"}
    }),
    mounted() {
        var globv = this;
        globv.contentRef = globv.$slots.default[0].elm
        globv.contentHeight = globv.contentRef.offsetHeight;
        
        window.addEventListener('resize', globv.adjustHeight);
        window.addEventListener('orientationchange', globv.adjustHeight);

        if (!globv.actionWord) {
            globv.actionWord = "Read";
        }

        if (!globv.heightLimit) {
            globv.heightLimit = 105;
        }
        
        globv.label = globv.actionWord + " More";

        if (globv.contentHeight > globv.heightLimit) {
            globv.flexDir['flex-direction'] = "column-reverse";
        }
    },
    beforeDestroy() {
        var globv = this;
        window.removeEventListener('resize', globv.adjustHeight);
        window.removeEventListener('orientationchange', globv.adjustHeight);
    },
    methods: {
        toggleExpand: function() {
            var globv = this;
            if (globv.contentHeight > globv.heightLimit) {
                globv.isExpanded = !globv.isExpanded;

                if (globv.isExpanded) {
                    globv.label = globv.actionWord + " Less";
                }
                else {
                    globv.label = globv.actionWord + " More";
                }
            }
        },
        adjustHeight: function() {
            var globv = this;
            setTimeout(() => {
                globv.contentHeight = globv.contentRef.offsetHeight;
            }, 10);
        }
    },
    computed: {
        currHeight() {
            var globv = this;

            if (globv.contentHeight > globv.heightLimit) {
                return {
                    height: globv.isExpanded ? globv.contentHeight + 18 + 'px' : globv.heightLimit + 'px'
                }
            }

            return {};
        }
    }
}
</script>

<style lang="scss">
.expandableContent {
    overflow: hidden;
    transition: height 0.3s ease;
    position: relative;

    &::before {
        content: '';
        width: 100%;
        height: 2rem;
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(to bottom, transparent, #fffafa);
        background: linear-gradient(to bottom, transparent, var(--subjectBackgroundColor));
        opacity: 1;
        transition: opacity 0.3s ease;
    }
}

.expanded {
    &.expandableContent::before {
        opacity: 0;
    }
}

.moreBtn {
    width: 100%;
    cursor: pointer;
    color: slategrey;
    color: var(--lessMajorTextColor);

    &:hover ~ .expandableContent::before {
        filter: brightness(0.9);
    }

    &:hover {
        color: #2c3e50;
        color: var(--majorTextColor);
    }
}
</style>